export {default as DisclaimerSection} from './DisclaimerSection';
export {default as EulaFormSection} from './EulaFormSection';
export {default as LegalAcknowledgementSection} from './LegalAcknowledgementSection';
export {default as RegionAndLanguageSection} from './RegionAndLanguageSection';
export {default as GuardianSection} from './GuardianSection';
export {default as MainSocialChannelSection} from './MainSocialChannelSection';
export {default as CodeSelfServiceSection} from './CodeSelfServiceSection';
